import { PageLocatorMap } from '../types/PageLocatorMap';

export const activationPinVerifyPage = {
  alert: {
    error: 'activation-pin-verify-page.alert.error',
    success: 'activation-pin-verify-page.alert.success',
  },
  footer: {
    root: 'activation-pin-verify-page.footer.root',
  },
  form: {
    h1: 'activation-pin-verify-page.form.heading1',
    h3: 'activation-pin-verify-page.form.heading3',
    pinInput: (position: number): string =>
      `activation-pin-verify-page.form.pin-input-${position}`,
    pinInputError: 'activation-pin-verify-page.form.pin-error',
    resendPinLink: 'activation-pin-verify-page.form.resend-pin-link',
    root: 'activation-pin-verify-page.form.root',
  },
  header: {
    root: 'activation-pin-verify-page.header.root',
  },
} as const satisfies PageLocatorMap;
